import { cva } from 'class-variance-authority';

/**
 * Styles for PasswordRequirementList component
 * Uses design tokens for colors and spacing
 */
export const passwordRequirementListStyles = cva(
  [
    'bg-surface', // Surface color from design tokens
    'border',
    'border-outline-variant', // Outline variant color from design tokens
    'flex',
    'flex-col',
    'gap-3', // 12px gap between heading and requirements
    'p-4', // 16px padding
    'rounded-xl', // 12px border radius
  ],
  {
    variants: {},
    defaultVariants: {},
  }
);

export const passwordRequirementListHeadingStyles = cva(
  [
    'text-xs',
    'font-medium',
    'leading-4',
    'tracking-[0.4px]',
    'text-on-surface-variant', // On surface variant color from design tokens
  ],
  {
    variants: {},
    defaultVariants: {},
  }
);

export const passwordRequirementListItemsStyles = cva(
  [
    'flex',
    'flex-col',
    'gap-1', // 4px gap between requirements
  ],
  {
    variants: {},
    defaultVariants: {},
  }
);
